import { useEffect, useRef } from 'react';
import {
	checkTimeslotHasResources,
	checkTimeslotHasBadge,
	preventDefaultDrag,
} from '../../Utils/utils';
import { connect } from 'react-redux';
import { isWebview } from '../../Utils/is-webview';

const AuditoriumTabs = (props) => {
	const {
		timeSlot,
		translation,
		defaultTranslation,
		currentTab,
		hasVideoWall,
		hasPolls,
		event,
		toggleBadgeDialog,
		handleChangeTab,
		badgeForCurrentTimeslot,
		onGoToCredentials,
	} = props;

	const containerRef = useRef(null);
	const hideNetworkingRef = useRef(event?.hideAuditoriumNetworking);

	useEffect(() => {
		const prevHideNetworking = hideNetworkingRef.current;
		const currentHideNetworking = event?.hideAuditoriumNetworking;

		if (
			prevHideNetworking !== currentHideNetworking &&
			currentHideNetworking &&
			currentTab === 'networking'
		) {
			handleChangeTab('video')();
		}

		hideNetworkingRef.current = currentHideNetworking;
	}, [event?.hideAuditoriumNetworking, currentTab, handleChangeTab]);

	useEffect(() => {
		const element = containerRef.current;

		if (!element) {
			return undefined;
		}

		element.addEventListener('dragstart', preventDefaultDrag);

		return () => {
			element.removeEventListener('dragstart', preventDefaultDrag);
		};
	}, []);

	const timeslotHasResources = checkTimeslotHasResources(timeSlot);
	const timeslotHasBadge = checkTimeslotHasBadge(timeSlot);
	const userHasBadgeForTimeslot = !!badgeForCurrentTimeslot;

	return (
		<div
			ref={containerRef}
			role="presentation"
			tabIndex={-1}
			className="tabs-container"
		>
			<button
				type="button"
				className={`button-tab tab ${currentTab === 'video' ? 'active' : ''}`}
				onClick={handleChangeTab('video')}
			>
				<span>{translation?.auditorium.stageTab}</span>
			</button>
			{hasVideoWall && (
				<button
					type="button"
					className={`button-tab tab ${currentTab === 'wall' ? 'active' : ''}`}
					onClick={handleChangeTab('wall')}
				>
					<span>{translation?.auditorium.videoWallButton}</span>
				</button>
			)}
			{hasVideoWall && !event.hideAuditoriumNetworking && (
				<button
					type="button"
					className={`button-tab tab ${currentTab === 'networking' ? 'active' : ''}`}
					onClick={handleChangeTab('networking')}
				>
					<span>
						{translation?.sideMenu.audience ||
							defaultTranslation?.sideMenu.audience}
					</span>
				</button>
			)}
			{hasPolls && (
				<button
					type="button"
					className={`button-tab tab ${currentTab === 'polls' ? 'active' : ''}`}
					onClick={handleChangeTab('polls')}
				>
					<span>
						{translation?.polls?.polls || defaultTranslation?.polls?.polls}
					</span>
				</button>
			)}
			{timeslotHasResources && (
				<button
					type="button"
					className={`button-tab tab ${
						currentTab === 'resources' ? 'active' : ''
					}`}
					onClick={handleChangeTab('resources')}
				>
					<span>{translation?.auditorium.resourcesButton}</span>
				</button>
			)}
			{timeslotHasBadge && !isWebview() && (
				<button
					type="button"
					className="button-tab tab"
					onClick={
						userHasBadgeForTimeslot && onGoToCredentials
							? () => onGoToCredentials()
							: () => toggleBadgeDialog()
					}
				>
					<span>{translation?.auditorium?.badgeButton || 'BADGE'}</span>
				</button>
			)}
		</div>
	);
};
const mapStateToProps = (state) => {
	return {
		event: state.event.data,
		translation: state.languages.translations[state.languages.platformLanguage],
		defaultTranslation: state.languages.translations['en'],
	};
};

export default connect(mapStateToProps)(AuditoriumTabs);
